import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions

import { LoadScreen } from "../Common/LoadScreen";
import { ErrorScreen } from "../Common/ErrorScreen";
import * as Feedback from "../../common/Feedback/Feedback";
import { CrudlStatus, PageState } from "../../common/config/AppConstants";

import * as log from "../../common/Feedback/Log";

import { BPMKanban } from "../Common/BPMKanban";

import { WorkViewModel } from "./WorkViewModel";
import * as Format from "../../common/FormatFunctions";
import { WorkDisplay } from "./UI/WorkDisplay";
import { WorkItemDisplay } from "./UI/WorkItemDisplay";
import { formatRange } from "fullcalendar";
import { PartDisplay } from "../Products/legacy/UI/PartDisplay";
import { FlowItemDisplay } from "../Flows/UI/FlowItemDisplay";

export class WorksSchedule extends Component {
  constructor() {
    super();

    const DisplayState = {
      KANBAN: "KANBAN",
      STATION: "STATION",
      INFO: "INFO"
    };

    this.state = {
      // DISPLAY FLAGS
      pageState: PageState.IDLE,
      displayState: DisplayState.KANBAN,

      //DIALOG FLAGS
      toggleChangesMade: false,
      toggleDeleted: false,

      //DISPLAY VIEW
      editView: false,

      // DETAILS
      workList: [],
      originalEditedWork: "",
      editedWork: {},

      crudlState: CrudlStatus.LIST,

      //KANBAN DATA

      kanbanData: [],
      stationKanbanData: [],
      showWorkItem: false,
      associatedWorkItems: [],
      associatedFlowItems: [],
      displayData: null
    };

    //SET UP LOGGER AND VIEWMODEL
    this.logger = log;
    this.viewModel = new WorkViewModel(
      this.updateState,
      this.showError,
      this.showSuccess,
      this.showEmpty
    );
    this.DisplayState = DisplayState;
  }

  componentDidMount = () => {
    this.initialDataRender();
  };

  initialDataRender = async () => {
    await this.setPageData();
  };

  menuState = crudlStatus => {
    this.setState({
      menuItems: pr.getBreadcrumbMenuState(
        crudlStatus,
        "Work",
        "#/workSchedule"
      )
    });
  };

  setPageData = async () => {
    this.setState({ pageState: PageState.LOADING });

    await this.initialRenderKanban();
    this.menuState(CrudlStatus.LIST);

    this.setState({ pageState: PageState.IDLE });
  };

  initialRenderKanban = async () => {
    var renderFailed = false;
    this.setState({
      loaded: false,
      editLoaded: false,
      displayState: this.DisplayState.KANBAN,
      selectedStationId: null
    });
    var kanban = await this.viewModel.getStationByCodeTagKanban();
    if (Format.isNotNull(kanban)) {
      if (Format.isNotNull(kanban.swimLaneList)) {
        if (Format.isNotNull(kanban.swimLaneList[0])) {
          this.logger.info(kanban.swimLaneList[0]);

          this.setState({
            kanbanData: kanban.swimLaneList[0],
            displayState: this.DisplayState.KANBAN,
            pageState: PageState.IDLE
          });
        } else {
          renderFailed = true;
        }
      } else {
        renderFailed = true;
      }
    } else {
      renderFailed = true;
    }
    console.log(renderFailed);
    if (renderFailed === true) {
      this.setState({
        kanbanData: {},
        displayState: this.DisplayState.KANBAN,
        pageState: PageState.ERROR
      });

      this.showError("Kanban", null);
    }
  };

  cardSelected = data => {
    this.setState({
      displayState: this.DisplayState.INFO,
      displayData: data
    });
  };

  stationSelected = async laneId => {
    this.setState({ pageState: PageState.LOADING });

    let kanbanResponse = await this.viewModel.getStationByKanbanId(laneId);
    var kanban = {};
    var flowItems = {};
    var workItems = {};
    var failure = false;
    if (Format.isNotNull(kanbanResponse)) {
      if (
        Format.isNotNull(kanbanResponse.errorCode) &&
        kanbanResponse.errorCode === 0
      ) {
        if (Format.isNotNull(kanbanResponse.flowItemList)) {
          flowItems = kanbanResponse.flowItemList;
        }
        if (Format.isNotNull(kanbanResponse.workItemList)) {
          workItems = kanbanResponse.workItemList;
        }
        if (Format.isNotNull(kanbanResponse.kanbanBoardList)) {
          kanban = kanbanResponse.kanbanBoardList;
        }
      } else {
        failure = true;
      }
    } else {
      failure = true;
    }
    if (Format.isNotNull(kanban) && failure === false) {
      this.logger.info(kanban);
      this.logger.info(workItems);
      this.logger.info(flowItems);

      this.setState({
        stationKanbans: kanban,
        displayState: this.DisplayState.STATION,
        selectedStationId: laneId,
        associatedWorkItems: workItems,
        associatedFlowItems: flowItems
      });
    } else {
      this.showEmpty("Tool");
    }

    this.setState({ pageState: PageState.IDLE });
  };
  //View Model Link Functions

  showError = (display, crudlStatus) => {
    Feedback.showError(this.growl, display, crudlStatus);
  };

  showSuccess = (display, crudlStatus) => {
    Feedback.showSuccess(this.growl, display, crudlStatus);
  };

  showEmpty = display => {
    Feedback.showEmpty(this.growl, display);
  };

  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  // #region Cloud
  getStateValuesAsObject = () => {
    var externalObject = {};
    externalObject.selectedProducts = this.state.selectedProducts;
    externalObject.workBean = this.state.editedWork;

    return externalObject;
  };

  updateWork = async () => {
    this.setState({ pageState: PageState.LOADING });

    var stateVariables = this.getStateValuesAsObject();
    var workResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (workResponse.errorCode === 0) {
      this.setState({
        workEdited: false
      });
      this.updateWorkList(workResponse, CrudlStatus.UPDATE, stateVariables);
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  addWork = async () => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var workResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (workResponse.errorCode === 0) {
      this.setState({
        workEdited: false,
        workAdded: false
      });
      this.updateWorkList(workResponse, CrudlStatus.CREATE, stateVariables);
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  deleteWork = async () => {
    this.setState({ pageState: PageState.LOADING });

    var stateVariables = this.getStateValuesAsObject();

    var workResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (workResponse.errorCode === 0) {
      this.setState({
        workSelected: false
      });

      this.updateWorkList(workResponse, CrudlStatus.DELETE, stateVariables);
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };
  // #endregion

  // #region ViewFunctions

  updateBean = (field, value) => {
    this.setState(prevState => ({
      editedWork: {
        // object that we want to update
        ...prevState.editedWork, // keep all other key-value pairs
        [field]: value
      }
    }));
    this.logger.info(value);
  };

  updateWorkItemKanban = async kanbanBoard => {
    this.setState({ editLoaded: false });

    var response = await this.viewModel.updateWorkItemKanban(
      kanbanBoard,
      this.state.selectedStationId
    );

    if (response.errorCode === 0) {
      this.stationSelected(this.state.selectedStationId);
    } else {
      this.showError("Work Item", CrudlStatus.UPDATE);
      this.setState({ pageState: PageState.IDLE });
    }
  };

  editWorkButton = data => {
    window.scrollTo(0, 0);
    if (this.state.workAdded === true) {
      this.setState({
        editedWork: {},
        originalEditedWork: JSON.stringify({}),
        selectedProducts: [],
        crudlState: CrudlStatus.CREATE
      });
    } else {
      this.setState({
        editedWork: data,
        originalEditedWork: JSON.stringify(data),
        workAdded: false,
        crudlState: CrudlStatus.UPDATE
      });
    }
  };

  deleteWorkButton = data => {
    this.setState({
      editedWork: data
    });
    this.setState({ workDeleted: true });
  };

  validateChanges = () => {
    this.logger.info(this.state.originalEditedWork);
    this.logger.info(this.state.editedWork);
    if (
      this.state.originalEditedWork === JSON.stringify(this.state.editedWork)
    ) {
      this.discardChanges();
    } else {
      this.setState({ workChangesMade: true });
    }
  };

  discardChanges = () => {
    if (this.state.workAdded === true) {
      this.setState({
        workSelected: false,
        workEdited: false,
        workAdded: false,
        workChangesMade: false
      });
    } else {
      this.setState({
        workSelected: true,
        workEdited: false,
        workAdded: false,
        workChangesMade: false
      });
    }
  };

  runCreate = () => {
    this.setState(
      {
        workSelected: false,
        workEdited: true,
        workAdded: true,
        selectedWork: {}
      },
      () => {
        this.editWorkButton({});
      }
    );
  };
  runCrud = create => {
    if (create === true) {
      this.addWork();
    } else {
      this.updateWork();
    }
  };

  // #region View
  render() {
    const s = this.state;

    return (
      <div>
        <div
          className="ui-g dashboard"
          style={
            s.pageState === PageState.LOADING ? { pointerEvents: "none" } : {}
          }
        >
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />

          {/* <div className="ui-g-12">
            <pr.Toolbar style={{ backgroundColor: "light-gray" }}>
              <div className="p-toolbar-group-left">
                <pr.BreadCrumb
                  model={this.state.menuItems}
                  home={pr.getBreadcrumbMenuHome()}
                  style={{
                    backgroundColor: "transparent",
                    float: "left"
                  }}
                />
                <pr.Button
                  type="button"
                  icon="pi pi-arrow-left"
                  className="p-button-success"
                  onClick={f => this.initialRenderKanban()}
                  style={
                    this.state.displayState === this.DisplayState.STATION
                      ? { marginRight: ".25em", float: "right" }
                      : { display: "none" }
                  }
                ></pr.Button>
                <pr.Button
                  type="button"
                  icon="pi pi-arrow-left"
                  className="p-button-success"
                  onClick={f =>
                    this.stationSelected(this.state.selectedStationId)
                  }
                  style={
                    this.state.displayState === this.DisplayState.INFO
                      ? { marginRight: ".25em", float: "right" }
                      : { display: "none" }
                  }
                ></pr.Button>
                <pr.Button
                  type="button"
                  icon="pi pi-refresh"
                  className="p-button-success"
                  onClick={f => this.initialRenderKanban()}
                  style={
                    this.state.pageState !== PageState.ERROR
                      ? { display: "none" }
                      : { marginRight: ".25em", float: "right" }
                  }
                ></pr.Button>
              </div>
            </pr.Toolbar>
          </div> */}
          <React.Fragment>
            {this.state.pageState === PageState.ERROR && (
              <ErrorScreen
                loading={this.state.pageState === PageState.LOADING}
                refresh={this.setPageData}
              />
            )}
            {this.state.pageState === PageState.LOADING && <LoadScreen />}
            {this.state.pageState === PageState.IDLE && (
              <React.Fragment>
                <div className="ui-g-12">
                  <pr.Button
                    type="button"
                    icon="pi pi-arrow-left"
                    className="p-button-success"
                    onClick={f => this.initialRenderKanban()}
                    style={
                      this.state.displayState === this.DisplayState.STATION
                        ? { marginRight: ".25em", float: "left" }
                        : { display: "none" }
                    }
                  ></pr.Button>
                  <pr.Button
                    type="button"
                    icon="pi pi-arrow-left"
                    className="p-button-success"
                    onClick={f =>
                      this.stationSelected(this.state.selectedStationId)
                    }
                    style={
                      this.state.displayState === this.DisplayState.INFO
                        ? { marginRight: ".25em", float: "left" }
                        : { display: "none" }
                    }
                  ></pr.Button>
                  <pr.Button
                    type="button"
                    icon="pi pi-refresh"
                    className="p-button-success"
                    onClick={f => this.initialRenderKanban()}
                    style={
                      this.state.pageState !== PageState.ERROR
                        ? { display: "none" }
                        : { marginRight: ".25em", float: "left" }
                    }
                  ></pr.Button>

                  <div>
                    <BPMKanban
                      data={this.state.kanbanData}
                      laneSelected={this.stationSelected}
                      visible={
                        this.state.displayState === this.DisplayState.KANBAN
                      }
                      cardDraggable={false}
                    />
                    {this.getDifferentKanbans()}
                    {this.getSelectionView()}
                  </div>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </div>
      </div>
    );
  }

  getDifferentKanbans = () => {
    var kanbanAray = [];
    var index = 0;
    if (Format.isNotNull(this.state.stationKanbans)) {
      this.state.stationKanbans.forEach(element => {
        if (Format.isNotNull(element.swimLaneList[0])) {
          this.logger.info(element.swimLaneList[0]);

          kanbanAray[index] = (
            <BPMKanban
              data={element.swimLaneList[0]}
              cardSelected={this.cardSelected}
              visible={this.state.displayState === this.DisplayState.STATION}
              cardMoved={this.updateWorkItemKanban}
              cardDraggable={true}
            />
          );
        }
        index++;
      });
    }

    return kanbanAray;
  };
  getSelectionView = () => {
    if (!Format.isNotNull(this.state.displayData)) {
      return <React.Fragment></React.Fragment>;
    }
    var data = this.state.displayData;
    this.logger.info(this.state.displayData);
    var workItemBean = {};
    var flowItemBean = {};
    workItemBean = this.getWorkItemForKanbanCard(data);
    if (Format.isNotNull(workItemBean)) {
      flowItemBean = this.getFlowItemForKanbanCard(data, workItemBean);
    }
    if (this.state.displayState !== this.DisplayState.INFO) {
      return <React.Fragment></React.Fragment>;
    }
    return (
      <React.Fragment>
        <div className="ui-g-12 row">
          <div className="ui-g-6 card-cell">
            {"Overall Part/Product"}
            <WorkItemDisplay data={workItemBean} />
          </div>
          <div className="ui-g-6 card-cell">
            {"Current Position"}
            <FlowItemDisplay data={flowItemBean}></FlowItemDisplay>
          </div>
        </div>
      </React.Fragment>
    );
  };

  getWorkItemForKanbanCard = kanbanCard => {
    var associatedWorkItem = null;
    if (Format.isNotNull(kanbanCard)) {
      if (Format.isNotNull(this.state.associatedWorkItems)) {
        this.logger.info(this.state.associatedWorkItems);
        this.state.associatedWorkItems.forEach(workItem => {
          if (kanbanCard.cardId === workItem.id) {
            associatedWorkItem = workItem;
          }
        });
      }
    }
    this.logger.info(associatedWorkItem);
    return associatedWorkItem;
  };
  getFlowItemForKanbanCard = (kanbanCard, associatedWorkItem) => {
    var associatedFlowItem = null;
    if (Format.isNotNull(kanbanCard)) {
      if (Format.isNotNull(this.state.associatedFlowItems)) {
        if (Format.isNotNull(associatedWorkItem)) {
          this.state.associatedFlowItems.forEach(flowItem => {
            if (associatedWorkItem.flowItemId === flowItem.id) {
              associatedFlowItem = flowItem;
            }
          });
        }
      }
    }
    this.logger.info(associatedFlowItem);
    return associatedFlowItem;
  };
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Work/WorksSchedule.js